module.exports = __webpack_public_path__ + "static/media/C (13).2399b8d4.jpg";